import * as React from "react";
import { XTerm } from "@pablo-lion/xterm-react";
import me1 from './me1.ansi';
import me2 from './me2.ansi';
import me3 from './me3.ansi';
import me4 from './me4.ansi';
import me5 from './me5.ansi';
import pic1 from './me1.png';
import pic2 from './me2.png';
import pic3 from './me3.png';
import pic4 from './me4.png';
import pic5 from './me5.png';
import { Box, Button } from "@mui/material";

export const MobileTerminalComponent = () => {
	const [pic, setPic] = React.useState(me1);
	const xterm = React.useRef(null);
	React.useEffect(() => {
		fetch(pic)
		.then(r => r.text())
		.then(async text => {
			text = text.replaceAll("\\u001b", "\u001b");
			text = text.replace(/(\r\n|\n|\r)/gm, "");
			xterm?.current.write(text);
			await new Promise((resolve) => 
				setTimeout(resolve, 10));
		});
	}, [pic]);
	var options = {
		cols: 200,
		rows: 100,
		scrollback:0,
		fontSize:3.5,
		cursorInactiveStyle:'none',
		theme:{
			cursor:'#000000',
			background:'#000000'
		},
	};
	const imageStyle = {
		width:"100px", 
		height:"100px", 
		borderRadius:'5px',
		border:'solid', 
		borderWidth:'1px',
		borderColor:'black'
	}
	return (
		<Box display="flex" flexDirection={'column'} justifyContent={'space-around'} alignContent={'center'}>
			<div>
				<XTerm  options={options} ref={xterm} />
			</div>
			<Box display='flex' flexDirection={'row'} overflow={'none'} justifyContent={'space-around'} alignContent={'center'} style={{padding:'5px', borderColor:'black', border:'solid', borderWidth:'1px'}}>
				<Button style={imageStyle} onClick={() => setPic(me1)}>
					<img style={imageStyle} src={pic1} width="100"/>
				</Button>
				<Button style={imageStyle} onClick={() => setPic(me2)}>
					<img style={imageStyle} src={pic2} width="100"/>
				</Button>
				<Button style={imageStyle} onClick={() => setPic(me3)}>
					<img style={imageStyle} src={pic3} width="100"/>
				</Button>
				<Button style={imageStyle} onClick={() => setPic(me4)}>
					<img style={imageStyle} src={pic4} width="100"/>
				</Button>
				<Button style={imageStyle} onClick={() => setPic(me5)}>
					<img style={imageStyle} src={pic5} width="100"/>
				</Button>
			</Box>
		</Box>
	);
};  